/**
 * KİLİT EKRANINDA DENEME SINIRI (kullanıcı kararı 16.10.2026, "Parafon
 * sunucusuna yedek" maddesi).
 *
 * İlk 5 yanlış parola serbest; sonra her yanlışta artan bekleme: 30 sn, 1 dk,
 * 2 dk, 4 dk… en çok 15 dk. Doğru parola sayacı sıfırlar.
 *
 * SAYAÇ YALNIZCA SAYFANIN BELLEĞİNDE. Kalıcı yazmak (IndexedDB, localStorage)
 * profil dışına bilgi yazmak olurdu (CLAUDE.md §8: profil dışında yalnızca
 * etiket, kimlik, tarih, KDF, sarmallar). Sayfayı yenileyen sayacı sıfırlar —
 * bu bilinçli: asıl koruma parola çözmenin bilerek yavaş olması; bu sınır
 * yalnızca elle art arda denemeyi yavaşlatır.
 */

import { M } from "../dil";

export const SERBEST_DENEME = 5;
const ILK_BEKLEME_MS = 30_000;
const EN_COK_BEKLEME_MS = 15 * 60_000;

/** `yanlis` yanlıştan sonra beklenecek süre. */
export function beklemeMs(yanlis: number): number {
  if (yanlis < SERBEST_DENEME) return 0;
  return Math.min(EN_COK_BEKLEME_MS, ILK_BEKLEME_MS * 2 ** (yanlis - SERBEST_DENEME));
}

export interface DenemeSayaci {
  /** Şu an denenebilir mi; değilse kalan milisaniye. */
  kalanMs(): number;
  yanlis(): void;
  dogru(): void;
}

export function createDenemeSayaci(saat: () => number = () => Date.now()): DenemeSayaci {
  let adet = 0;
  let son = 0;
  return {
    kalanMs: () => Math.max(0, son + beklemeMs(adet) - saat()),
    yanlis() {
      adet += 1;
      son = saat();
    },
    dogru() {
      adet = 0;
      son = 0;
    },
  };
}

/** Sayfa boyunca tek sayaç: kilit ekranı yeniden çizilse de sürer. */
export const kilitDenemeSayaci: DenemeSayaci = createDenemeSayaci();

/** Worker'ın "parola yanlış" hatası mı (sarmal etiketi tutmadı). */
export function yanlisParolaMi(e: unknown): boolean {
  const d = (e as { detail?: unknown } | null)?.detail;
  return d === "sarmal:parola:etiket" || d === "sarmal:ifade:etiket";
}

export function beklemeMesaji(ms: number): string {
  const sn = Math.ceil(ms / 1000);
  const sure = sn < 60 ? M.hareketler.deneme.saniye(sn) : M.hareketler.deneme.dakika(Math.ceil(sn / 60));
  return M.hareketler.deneme.bekleme(sure);
}

/** Deneme sınırından geçirir: bekleme varsa denemez; yanlış sırrı sayar, doğruda sıfırlar. */
export async function denemeSinirli<T>(dene: () => Promise<T>): Promise<T> {
  const kalan = kilitDenemeSayaci.kalanMs();
  if (kalan > 0) throw new Error(beklemeMesaji(kalan));
  try {
    const r = await dene();
    kilitDenemeSayaci.dogru();
    return r;
  } catch (e: unknown) {
    if (yanlisParolaMi(e)) kilitDenemeSayaci.yanlis();
    throw e;
  }
}
